(() => {
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motionPreference.matches || !('IntersectionObserver' in window)) return;
  if (document.documentElement.dataset.reevamMotionReady === 'true') return;
  document.documentElement.dataset.reevamMotionReady = 'true';

  const selectors = [
    ['[id*="media_with_content_RVymQU"] .media-block', 'reevam-reveal-image', false],
    ['[id*="media_with_content_RVymQU"] .media-with-content__content > .group-block-content > *', 'reevam-reveal-copy', true],
    ['[id*="product_list_themegen"] .resource-list__item', 'reevam-reveal-card', true],
    ['[id*="product_list_WK7wKh"] .resource-list__item', 'reevam-reveal-card', true],
    ['.product-grid-container .product-grid--grid > .product-grid__item', 'reevam-reveal-card', true],
    ['.reevam-difference__item', 'reevam-reveal-copy', true],
    ['.media-with-content:has(a[href*="instagram.com/reevam_store"]) .media-block', 'reevam-reveal-image', false],
    ['.media-with-content:has(a[href*="instagram.com/reevam_store"]) .media-with-content__content > .group-block-content > *', 'reevam-reveal-copy', true],
    ['[id$="section_x8mrnx"] .text-block', 'reevam-reveal-copy', true]
  ];

  const seen = new Set();
  const items = [];
  for (const [selector, kind, stagger] of selectors) {
    let nodes = [];
    try { nodes = document.querySelectorAll(selector); } catch (_) { continue; }
    let index = 0;
    for (const node of nodes) {
      if (seen.has(node)) continue;
      seen.add(node);
      node.classList.add('reevam-scroll-reveal', kind);
      if (stagger) {
        node.style.setProperty('--reevam-reveal-delay', Math.min(index, 3) * 75 + 'ms');
      }
      items.push(node);
      index += 1;
    }
  }

  if (!items.length) return;
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  }, { root: null, rootMargin: '0px 0px -6% 0px', threshold: 0.08 });

  items.forEach((item) => observer.observe(item));
})();